import { render, staticRenderFns } from "./AgreementChildSupport.vue?vue&type=template&id=70fc1510"
import script from "./AgreementChildSupport.vue?vue&type=script&lang=js"
export * from "./AgreementChildSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports